import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Icon from '../AppIcon';
import Button from './Button';

const BreadcrumbNavigation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const routeMap = {
    '/dashboard': { label: t('dashboard'), icon: 'LayoutDashboard' },
    '/customer-management': { label: t('customerManagement'), icon: 'Users' },
    '/product-catalog-management': { label: t('productCatalog'), icon: 'Package' },
    '/category-management': { label: t('categoryManagement'), icon: 'Tags' },
    '/order-management': { label: t('orderManagement'), icon: 'ShoppingCart' }
  };

  const generateBreadcrumbs = () => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    const breadcrumbs = [];

    // Always start with Dashboard as home
    if (location.pathname !== '/dashboard') {
      breadcrumbs.push({
        label: t('dashboard'),
        path: '/dashboard',
        icon: 'LayoutDashboard',
        isActive: false
      });
    }

    // Build breadcrumbs from path segments
    let currentPath = '';
    pathSegments.forEach((segment, index) => {
      currentPath += `/${segment}`;
      const routeInfo = routeMap[currentPath];
      
      if (routeInfo) {
        breadcrumbs.push({
          label: routeInfo.label,
          path: currentPath,
          icon: routeInfo.icon,
          isActive: index === pathSegments.length - 1
        });
      }
    });

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  // Don't show breadcrumbs on login page or if only one item
  if (location.pathname === '/login' || breadcrumbs.length <= 1) {
    return null;
  }

  const handleBreadcrumbClick = (path) => {
    navigate(path);
  };

  return (
    <nav className="flex items-center space-x-2 py-3 px-4 bg-surface border-b border-border" aria-label="Breadcrumb">
      <Icon name="Home" size={16} className="text-muted-foreground" />
      
      {breadcrumbs.map((breadcrumb, index) => (
        <React.Fragment key={breadcrumb.path}>
          {/* Separator */}
          {index > 0 && (
            <Icon name="ChevronRight" size={14} className="text-muted-foreground" />
          )}
          
          {/* Breadcrumb Item */}
          {breadcrumb.isActive ? (
            <span className="flex items-center space-x-2 text-sm font-medium text-foreground">
              <Icon name={breadcrumb.icon} size={16} />
              <span>{breadcrumb.label}</span>
            </span>
          ) : (
            <Button
              variant="ghost"
              onClick={() => handleBreadcrumbClick(breadcrumb.path)}
              className="flex items-center space-x-2 text-sm text-muted-foreground hover:text-foreground transition-micro px-2 py-1 h-auto"
            >
              <Icon name={breadcrumb.icon} size={16} />
              <span>{breadcrumb.label}</span>
            </Button>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default BreadcrumbNavigation;
